/**
 * Graph sections of the field graphs area (water potential / accumulated
 * water inputs / soil temperature), shared by the Field View
 * (DashboardContent) and the Farm View "Field details" tab so both decide
 * which graph tabs to offer, and how to track them, the same way.
 *
 * Pure on purpose: callers resolve the field / feature-flag checks and pass
 * the results in, so these rules can be unit tested without the managers.
 */

const GRAPH_SECTION_EVENTS = {
  drop: 'Water Section Load',
  temperature: 'Soil Temperature Section Load',
  accumulated: 'Accumulated Water Inputs Section Load',
};

// Mixpanel event for a graph section. Unknown sections fall back to the
// accumulated event, as the Field View always has.
const graphSectionEvent = (section) =>
  GRAPH_SECTION_EVENTS[section] ?? GRAPH_SECTION_EVENTS.accumulated;

// Icons for GraphToggle. Water potential is always offered; accumulated when
// the field supports it; soil temperature only when the feature flag is on
// AND the field has soil temperature data. Hidden slots stay `null` so the
// array keeps its fixed shape.
const buildGraphToggleIcons = ({
  showAccumulated,
  temperatureFlag,
  hasSoilTemperatureData,
}) => [
  'drop',
  showAccumulated ? 'accumulated' : null,
  temperatureFlag && hasSoilTemperatureData ? 'temperature' : null,
];

module.exports = {
  GRAPH_SECTION_EVENTS,
  graphSectionEvent,
  buildGraphToggleIcons,
};
